/* eslint-disable */
// Forsidens blokke for /business. Rækkefølgen er kunderejsen: problem → hvad vi overtager →
// bevis (portal) → pris → onboarding → afgrænsning → netværk → viden.

import { BILLEDER } from "./billeder";

export const HOME_BLOCKS = [
  {
    type: "split",
    heading: "Fem leverandører. Fem logins. Og dig i midten.",
    intro:
      "Sådan ser administrationen ud hos de fleste vognmænd. Hver leverandør passer sit, ingen har det fulde billede, og ejeren er den, der binder det sammen efter fyraften.",
    columns: [
      {
        title: "Som det er i dag",
        items: [
          "En bogholder, der kender bilagene, men ikke bilerne",
          "Et flådesystem, der ved hvor bilen er, men ikke hvad den tjener",
          "Et regneark med chaufførernes udløbsdatoer, hvis der er et",
          "En revisor, der ser tallene en gang om året",
          "Aftaler på diesel, leasing og forsikring, ingen holder op mod fakturaen",
          "Dig, der fakturerer og rykker om aftenen",
        ],
      },
      {
        title: "Med Votra Business",
        items: [
          "Én leverandør, der både fører bogen og kender bilerne",
          "Fakturering og debitoropfølgning som fast rutine",
          "Løn og chaufførafregning til tiden, hver gang",
          "Bilernes aftaler, beløb og frister samlet pr. bil",
          "Chaufførdokumenter med udløbsdatoer på samme bord som økonomien",
          "Én fast rådgiver og én portal, hvor du kan se det hele",
        ],
      },
    ],
  },
  {
    type: "cards",
    heading: "Tre ting der gør os anderledes",
    items: [
      {
        title: "Vi udfører, vi rådgiver ikke bare",
        desc: "Forskellen mellem «du bør følge dine debitorer» og «vi følger dine debitorer». Vi tager opgaverne, ikke bare samtalen om dem.",
      },
      {
        title: "Vi forstår bilerne, ikke kun bilagene",
        desc: "Leasing, forsikring, brændstof, service, dæk, skader og udløbsdatoer, og hvad en bil faktisk koster om måneden. På samme bord som regnskabet.",
      },
      {
        title: "Menneske og portal",
        desc: "Du får en fast rådgiver og et system, hvor du selv kan se kontrakter, dokumenter, moms, likviditet og aftaler. Bogholderen har ingen portal. Softwarefirmaet har ingen bogholder.",
      },
    ],
  },
  {
    type: "media",
    image: BILLEDER.vaerksted,
    alt: "Lastbil på værksted med løftekrog hængende over den åbne motor",
    caption:
      "Vi sidder ikke kun med bilagene. Et serviceeftersyn, et dæksæt og en skade flytter bilens resultat, og det er derfor tallene kommer til at passe.",
  },
  { type: "areas", heading: "Hvad vi overtager", intro: "Syv områder i den rækkefølge, en vognmand møder dem. Du vælger, hvor meget du afleverer." },
  {
    type: "pillars",
    tone: "dark",
    overline: "Din virksomhed samlet ét sted",
    heading: "Det er ikke kun rådgivning. Det er din virksomhed i ét system.",
    intro:
      "Du får en fast rådgiver og en portal, hvor økonomien, medarbejderne, aftalerne og dokumenterne ligger samme sted. Det er forskellen på en bogholder, der sender et regneark, og en driftsafdeling, du kan logge ind i.",
    items: [
      { label: "Økonomi", title: "Bogføring, moms og likviditet", desc: "Status på den løbende bogføring, momsperioder og opgørelser, og overblik over bank og likviditet." },
      { label: "Medarbejdere", title: "Kontrakter og dokumentation", desc: "Ansættelseskontrakter med kørekort, EU-bevis, førerkort og ADR, med udløbsdatoer på hvert dokument." },
      { label: "Rådgiver", title: "Din faste kontaktperson", desc: "Du skriver til et menneske, der kender din forretning, ikke til en supportkø med et sagsnummer." },
      { label: "Kontrol", title: "Kvartalsgennemgang", desc: "Kvartalsvis gennemgang dokumenteret i portalen, så du kan se hvad der blev besluttet og hvorfor." },
      { label: "Kontrakter", title: "Underskrift i to led", desc: "Dine aftaler med Votra Business underskrives digitalt i to led, og status er synlig hele vejen." },
      { label: "Aftaler og bilag", title: "Transport-aftaler pr. bil", desc: "Forsikring, leasing og brændstof med leverandør, beløb, periode og dokument, plus arkiv over fakturaer." },
    ],
    link: { label: "Se hele portalen", to: "/business/portal" },
  },
  {
    type: "callout",
    title: "Bogholder, revisor eller controller, hvad er det du mangler?",
    text: "Bogholderen registrerer det, der er sket. Revisoren erklærer sig om årsregnskabet. Controlleren bruger tallene fremad: hvad tjener hver bil, hver chauffør og hver kontrakt. Vi dækker bogholderi og controlling, ikke revision. Og vi laver opdelingen pr. bil, som er den, der afgør om forretningen løber rundt.",
    link: { label: "Se hvordan vi regner resultat pr. bil", to: "/business/financial-controlling" },
  },
  {
    type: "media",
    flip: true,
    overline: "Controlling",
    image: BILLEDER.resultatPrBil,
    alt: "Hver bil vist som en søjle i forskellig højde, tegnet i guld på mørk baggrund",
    heading: "Hver bil har sit eget regnskab",
    text:
      "Et samlet regnskab fortæller, om året gik. Opdelingen pr. bil fortæller, hvilken bil der bærer, og hvilken der trækker ned. Det er den opdeling, beslutningen om næste bil, næste chauffør og næste kontrakt skal hvile på.",
    link: { label: "Sådan regner vi resultat pr. bil", to: "/business/financial-controlling" },
  },
  { type: "portal" },
  { type: "packages" },
  { type: "onboarding", intro: "Du skal ikke selv samle noget. Vi henter ind, rydder op og sætter rutinerne, og fra måned to er det bare drift." },
  {
    type: "callout",
    title: "Ærligt om omkostninger og rammeaftaler",
    text: "Vi lover dig ikke en procentsats. Vi gennemgår dine faste omkostninger post for post, henter tilbud gennem vores partnernetværk og lægger forskellen frem i kroner, du beslutter, og aftalen er din. Netværket er i dag stærkest på forsikring gennem samarbejdet med fleetpartner.dk, og det skriver vi, i stedet for at påstå aftaler på tyve områder.",
    link: { label: "Se hvad netværket dækker", to: "/business/rammeaftaler" },
  },
  {
    type: "callout",
    title: "Ikke vognmand? Vi laver også regnskab for andre virksomheder",
    text: "Vores dybeste specialisering er transport. Men driftsmodellen er den samme for enhver lille virksomhed, hvor ejeren laver arbejdet om dagen og administrationen om aftenen: bogføring, moms, løn, fakturering og økonomistyring ud af huset, uden fleet-delen.",
    link: { label: "For virksomheder uden flåde", to: "/business/andre-virksomheder" },
  },
  { type: "boundaries" },
  {
    type: "media",
    overline: "Compliance",
    image: BILLEDER.dokumenter,
    alt: "Stak af dokumenter med gyldne kanter og små markeringer for frister",
    heading: "Papirerne har en udløbsdato, også når ingen holder øje",
    text:
      "Kørekort, EU-bevis, førerkort, ADR, syn og tilladelser. Hvert dokument ligger pr. medarbejder og pr. bil med den dato, det udløber, så det ikke er en mappe i en skuffe, der afgør om bilen må køre i morgen.",
    link: { label: "Se hvad vi holder øje med", to: "/business/compliance" },
  },
  { type: "partners", intro: "Hvert logo har en rolle, og vi skriver rollen. Aftaler med leverandører indgås mellem dig og leverandøren, vi laver arbejdet omkring dem." },
  { type: "articles", heading: "Viden om økonomi og drift", intro: "Konkret viden om det, der afgør om en vognmandsforretning tjener penge." },
];
